<template>
  <div class="progress-bar__bar">
    <span
      v-for="index in getMilestones"
      :key="index"
      class="progress-bar__bar-marker"
      :class="{ solid: raised >= (goal / getMilestones) * index }"
    >
    </span>

    <div class="progress-bar__bar-bar">
      <span ref="bar"></span>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(ScrollTrigger, CSSPlugin)

export default {
  props: {
    raised: {
      type: String,
      default: '',
    },
    goal: {
      type: String,
      default: '',
    },
    milestones: {
      type: String,
      default: '',
    },
  },
  computed: {
    getMilestones: function() {
      return Number(this.milestones)
    },
  },
  methods: {
    scrollFill() {
      gsap.to(this.$refs.bar, {
        scrollTrigger: {
          trigger: this.$refs.bar,
          // toggleActions: 'restart none none reset',
          start: 'top 95%',
        },
        width: (this.raised / this.goal) * 100 + '%',
        duration: 1.5,
        ease: 'expo.out',
      })
    },
  },
  mounted: function() {
    this.scrollFill()
  },
}
</script>
